import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "../../../../../common/services/api-client.service";
import { ITplArbetsorderDestinerbaraMottagningsplatserQuery, ITplArbetsorderDestinerbaraMottagningsplatserQueryResponse } from "../../models/queries";

@Injectable({
    providedIn: "root"
})
export class OmdestineraService {
    private readonly apiClient = inject(ApiClientService);

    getDestinerbaraMottagningsplatser(arbetsorderIds: number[], handelssortimentId: number): Observable<ITplArbetsorderDestinerbaraMottagningsplatserQueryResponse[]> {
        const request: ITplArbetsorderDestinerbaraMottagningsplatserQuery = {
            arbetsorderIds: arbetsorderIds,
            handelssortimentId: handelssortimentId
        };

        return this.apiClient.post<ITplArbetsorderDestinerbaraMottagningsplatserQuery, ITplArbetsorderDestinerbaraMottagningsplatserQueryResponse[]>(
            "transportplanera/arbetsorder/destinerbaramottagningsplatser",
            request,
            false
        );
    }
}
